<template>
    <b-container fluid>
        <b-row v-if="!hideSidebar">
            <b-col cols="0" lg="2" class="mv-sidebar d-none d-lg-block pt-4">
                <slot name="aboveNavSidebar"></slot>
                <NavSidebar v-if="!hideNavSidebar" />
                <slot name="sidebar"></slot>
            </b-col>
            <b-col cols="12" lg="10" class="mv-main pt-4">
                <slot></slot>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col cols="12" class="mv-main pt-4">
                <slot></slot>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import NavSidebar from "@/components/NavSidebar/NavSidebar";
export default {
    name: "MainContainer",
    props: {
        hideSidebar: {
            type: Boolean,
            default: false
        },
        hideNavSidebar: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NavSidebar
    },
    computed: {
        hasSidebarSlot() {
            return !!this.$slots["sidebar"];
        }
    }
};
</script>
